import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import API_BASE_URL from '../apiConfig'; // <--- NEW IMPORT
import '../App.css'; 

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password !== confirmPassword) { setError("Passwords do not match."); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }

    setLoading(true);
    try {
        // --- CHANGED URL HERE ---
        await axios.post(`${API_BASE_URL}/reset-password`, { token, new_password: password });
        setSuccess(true);
    } catch (err) {
        setError(err.response?.data?.detail || "Failed to reset password. Link may be expired.");
    } finally {
        setLoading(false);
    }
  };

  if (!token) return <div className="App"><header className="App-header"><h2>Invalid Link</h2></header></div>;

  return (
    <div className="App">
      <Navbar />
      <header className="App-header" style={{minHeight: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        
        <div className="form-container" style={{
            textAlign: 'center', 
            padding: '40px', 
            maxWidth: '450px', 
            width: '90%', 
            height: 'auto', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <h2 style={{textAlign: 'center', marginBottom: '20px'}}>Set New Password</h2>
            
            {success ? (
                <div style={{width: '100%', textAlign: 'center'}}>
                    <h3 style={{color: '#2e7d32'}}>Success!</h3>
                    <p style={{marginBottom: '30px', color: '#555'}}>Your password has been updated.</p>
                    
                    <Link to="/login" className="generate-button" style={{
                        display: 'block', 
                        width: '100%', 
                        textDecoration: 'none', 
                        textAlign: 'center', 
                        padding: '12px 0',
                        margin: '0'
                    }}>
                        Login with New Password
                    </Link>
                </div>
            ) : (
                <form onSubmit={handleSubmit} style={{width: '100%'}}>
                    {error && <p className="error-message">{error}</p>}
                    
                    <div className="form-group" style={{textAlign: 'left'}}>
                        <label>New Password</label>
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                    <div className="form-group" style={{textAlign: 'left'}}>
                        <label>Confirm Password</label>
                        <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                    </div>

                    <button className="generate-button" type="submit" disabled={loading} style={{width: '100%', marginTop: '15px'}}>
                        {loading ? "Resetting..." : "Reset Password"}
                    </button>
                </form>
            )}
        </div>
      </header>
      <Footer />
    </div>
  );
}

export default ResetPasswordPage;